import dayjs from 'dayjs';

export const getActFormDate = ({
  date,
  startTime,
}: {
  date: string;
  startTime: string;
}) => {
  const timePart = dayjs(startTime).format('HH:mm:ss');
  const datePart = dayjs(date).format('YYYY-MM-DD');
  const current = dayjs(`${datePart} ${timePart}`);

  return current.isValid() ? current.toISOString() : null;
};
